<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" custom-class="dialog-table" @close="close">
        <slot name="toolBar"></slot>
        <div class="pagination-table-header" v-if="showSearchForm">
            <div class="pagination-table-search-form">
                <el-form :inline="true" :model="tableList.searchForm" class="pagination-search-form" size="mini">
                    <slot name="searchForm"></slot>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-table
            style="min-height: 300px;"
            :empty-text="emptyText"
            :data="tableList.data"
            v-loading="tableList.loading">
            <slot name="tableColumns"></slot>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableList.count"
                :current-page.sync="tableList.page"
                :page-size.sync="tableList.pageSize"
                @size-change="handlePageSizeChange"
                @current-change="handlePageChange"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "DialogTable",
    props:
    {
        tableList: Object,
        title: String,
        emptyText: {
            default: '暂无数据',
            type: String,
        },
        close: {
            type: Function,
            default: ()=>{}
        }
    },
    data()
    {
        return {
            loading: false,
            dialogVisible: false,
        }
    },
    mounted()
    {
    },
    methods:
    {
        onSearch() {
            this.load();
        },
        show()
        {
            this.dialogVisible = true;
            this.load();
        },
        hide()
        {
            this.dialogVisible = false;
        },
        handlePageSizeChange(val)
        {
            this.load();
        },
        handlePageChange(val)
        {
            this.load();
        },
        load()
        {
            this.loading = true;
            return this.tableList.load().then(()=>this.loading=false);
        },
    },
    computed:
    {
        showSearchForm()
        {
            return this.$slots.searchForm;
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/table/DialogTable.vue